import { branding } from '@/lib/marketing/content'

export function BrandSection() {
  return (
    <section className="py-16 sm:py-24">
      <div className="max-w-[960px] mx-auto px-4 sm:px-6">
        <div className="bg-[#001716] rounded-2xl border border-[#E4FFE7]/[0.08] p-6 sm:p-10 overflow-hidden shadow-[0_8px_32px_-8px_rgba(0,0,0,0.4)]">
          {/* Decorative gradient */}
          <div className="absolute top-0 right-0 w-80 h-80 bg-[#71ED7F]/[0.04] rounded-full blur-[100px] pointer-events-none" />

          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            {/* Left: Branding Mock */}
            <div className="relative order-2 md:order-1">
              {/* Before/After comparison */}
              <div className="space-y-4">
                {/* "Before" - Generic */}
                <div className="relative opacity-50">
                  <div className="absolute -left-2 top-1/2 -translate-y-1/2 text-[10px] text-white/30 font-medium uppercase tracking-wider -rotate-90 origin-center">
                    Before
                  </div>
                  <div className="bg-[#1a1a1a] rounded-lg p-3 ml-4 border border-white/5">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-6 h-6 rounded bg-gray-600" />
                      <div className="h-3 w-20 bg-gray-600 rounded" />
                    </div>
                    <div className="space-y-1">
                      <div className="h-2 w-full bg-gray-700 rounded" />
                      <div className="h-2 w-3/4 bg-gray-700 rounded" />
                    </div>
                  </div>
                </div>

                {/* Arrow */}
                <div className="flex justify-center">
                  <svg className="w-5 h-5 text-[#71ED7F]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                  </svg>
                </div>

                {/* "After" - Branded */}
                <div className="relative">
                  <div className="absolute -left-2 top-1/2 -translate-y-1/2 text-[10px] text-[#71ED7F] font-medium uppercase tracking-wider -rotate-90 origin-center">
                    After
                  </div>
                  <div className="bg-[#002C2B] rounded-xl p-4 ml-4 border border-[#71ED7F]/20 shadow-[0_0_30px_-10px_rgba(113,237,127,0.2)]">
                    {/* Club header */}
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center">
                        <span className="text-white font-bold text-sm">BG</span>
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-white">{branding.example.name}</div>
                        <div className="text-[10px] text-white/40">{branding.example.domain}</div>
                      </div>
                    </div>

                    {/* Color palette */}
                    <div className="flex gap-2 mb-3">
                      <div className="w-8 h-8 rounded-lg bg-amber-500 ring-2 ring-amber-500/30" />
                      <div className="w-8 h-8 rounded-lg bg-orange-600" />
                      <div className="w-8 h-8 rounded-lg bg-amber-900" />
                      <div className="w-8 h-8 rounded-lg bg-stone-800" />
                    </div>

                    {/* Sample nav */}
                    <div className="flex items-center gap-3 text-[10px]">
                      <span className="text-amber-400">Book</span>
                      <span className="text-white/40">My Bookings</span>
                      <span className="text-white/40">Profile</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Content */}
            <div className="order-1 md:order-2">
              <div className="inline-block px-3 py-1 rounded-full bg-[#71ED7F]/10 border border-[#71ED7F]/20 text-[#71ED7F] text-xs font-semibold uppercase tracking-wider mb-4">
                {branding.badge}
              </div>

              <h2 className="text-2xl sm:text-3xl font-medium font-display text-white mb-4">
                {branding.headline}
              </h2>

              <p className="text-white/50 text-sm sm:text-base mb-6 leading-relaxed">
                {branding.description}
              </p>

              <ul className="space-y-3">
                {branding.features.map((feature, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <svg className="w-4 h-4 text-[#71ED7F] flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-white/60">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
